import { useQuery } from '@tanstack/react-query';
import { LAMBDA_FORMS } from './constants';
import authenticatedApi from './authenticatedApi';
import { useEffect, useRef } from 'react';
import { BulkPhase } from './getDocEditFile';

export const getRules = async (id?: string): Promise<any> => {
  if (!id) {
    return Promise.reject(new Error('Missing ID'));
  }

  return authenticatedApi.get<any>(`${LAMBDA_FORMS}/forms/${id}/rules`);
};

export const useRulesQuery = (id?: string) => {
  const prevCountRef = useRef<number>(-1);
  const lastGrowthAtRef = useRef<number>(Date.now());

  useEffect(() => {
    prevCountRef.current = -1;
    lastGrowthAtRef.current = Date.now();
  }, [id]);

  const q = useQuery({
    queryKey: ['rules', id],
    queryFn: () => getRules(id),
    enabled: !!id,
    refetchInterval: (query) => {
      if (!id) return false;
      const phase = sessionStorage.getItem(`bulk:${id}`);
      if (phase !== BulkPhase.DynamoId) return false;

      const rules = query.state.data?.data ?? [];
      const count = rules.length;

      if (count > prevCountRef.current) {
        prevCountRef.current = count;
        lastGrowthAtRef.current = Date.now();
        return 1000;
      }

      const stagnantFor = Date.now() - lastGrowthAtRef.current;
      if (stagnantFor >= 3000) {
        sessionStorage.removeItem(`bulk:${id}`);
        return false;
      }
      return 1000;
    },
    staleTime: 180_000,
    retry: false,
  });

  return q;
};
